import { render, staticRenderFns } from "./ai_upload.vue?vue&type=template&id=1306abc4&scoped=true"
import script from "./ai_upload.vue?vue&type=script&lang=js"
export * from "./ai_upload.vue?vue&type=script&lang=js"
import style0 from "./ai_upload.vue?vue&type=style&index=0&id=1306abc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1306abc4",
  null
  
)

export default component.exports